import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";
import StateSelect from "./StateSelect";

function AddressInput({
  onChange,
  Address1,
  Address2,
  City,
  State,
  Zip,
  size
}) {
  return (
    <React.Fragment>
      <Field multiline kind="group">
        <Control expanded>
          <Label size={size}>Address 1</Label>
          <Input
            autocomplete="new"
            name="Address1"
            size={size}
            type="text"
            value={Address1}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label size={size}>Address 2</Label>
          <Input
            autocomplete="new"
            name="Address2"
            size={size}
            type="text"
            value={Address2}
            onChange={onChange}
          />
        </Control>
        <Control>
          <Label size={size}>City</Label>
          <Input
            autocomplete="new"
            name="City"
            size={size}
            type="text"
            value={City}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label size={size}>State</Label>
          <StateSelect
            name="State"
            size={size}
            value={State}
            onChange={onChange}
          />
        </Control>
        <Control>
          <Label size={size}>Zip Code</Label>
          <Input
            autocomplete="new"
            name="Zip"
            size={size}
            type="text"
            value={Zip}
            onChange={onChange}
          />
        </Control>
      </Field>
    </React.Fragment>
  );
}

AddressInput.propTypes = {
  Address1: PropTypes.string,
  Address2: PropTypes.string,
  City: PropTypes.string,
  State: PropTypes.string,
  Zip: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.string
};
AddressInput.defaultProps = {
  Address1: "",
  Address2: "",
  City: "",
  State: "",
  Zip: "",
  size: ""
};
export default AddressInput;
